<template>
  <div class="instructions">
    <MainMenu />
    <div class="container mt-5 text-left">
      <div class="row">
        <div class="col-lg-8">
          <h3 class="font-weight-bold mb-3">Pre-reviewed test, traveller to Aruba</h3>
          <p class="p-text-large">
            In order to take full advantage of the pre-review, please make sure you download and are registered on the Aruba Health App. Please follow
            the following steps to register on the Aruba Health App in order to for quicker lanes at the airport upon arrival.
          </p>
        </div>
      </div>
      <hr class="mb-4" />
      <div class="row mt-3">
        <div class="col-lg-6">
          <h4>Step 1</h4>
          <p class="mb-1">Download the Aruba Health App on your mobile device:</p>
          <ul>
            <li><a target="_blank" :href="$androidAppUrl">Android</a></li>
            <li><a target="_blank" :href="$iOSAppUrl">iOS</a></li>
            <li><a target="_blank" :href="$pwaAppUrl">Web</a></li>
          </ul>
        </div>
      </div>
      <hr class="mb-5" />
      <div class="row mt-3">
        <div class="col-lg-6">
          <h4>Step 2</h4>
          <p>Register with your email (if you have a Gmail or Apple email, take advantage of the social login function).</p>
        </div>
        <div class="col-lg-6">
          <img class="screenshot" :src="require('@/assets/images/instruction-screenshots/login.png')" />
        </div>
      </div>
      <hr class="mb-5 mt-5" />
      <div class="row mt-3">
        <div class="col-lg-6">
          <h4>Step 3</h4>
          <ul>
            <li>Click the "add user" button</li>
            <li>Click "No" if you are not a resident or "Yes" if you are a resident</li>
            <li>Click on "Yes" if you have your ED card number with you</li>
          </ul>
        </div>
        <div class="col-lg-6">
          <div class="">
            <img class="screenshot" :src="require('@/assets/images/instruction-screenshots/add-new-user-btn.png')" />
            <img class="screenshot" :src="require('@/assets/images/instruction-screenshots/have-ed-number.png')" />
          </div>
        </div>
      </div>
      <hr class="mb-5 mt-5" />
      <div class="row mt-3">
        <div class="col-lg-6">
          <h4>Step 4</h4>
          <ul>
            <li>Fill in your first name and ED card number.</li>
            <li>Click on the "Next" button</li>
          </ul>
        </div>
        <div class="col-lg-6">
          <div class="">
            <img class="screenshot" :src="require('@/assets/images/instruction-screenshots/fill-in-ed.png')" />
          </div>
        </div>
      </div>
      <hr class="mb-5 mt-5" />
      <div class="row mt-3">
        <div class="col-lg-6">
          <h4>Step 5</h4>
          <div>Your ED card info will be prefilled for you in the Aruba Health App</div>
          <ul>
            <li>Fill in missing gender data</li>
            <li>Check the consent checkbox</li>
            <li>Click on the "Add" button</li>
          </ul>
        </div>
        <div class="col-lg-6">
          <div class="">
            <img class="screenshot" :src="require('@/assets/images/instruction-screenshots/add-user.png')" />
          </div>
        </div>
      </div>
      <hr class="mb-5 mt-5" />
      <div class="row mt-3">
        <div class="col-lg-6">
          <h4>Step 6</h4>
          <p>
            Your user and travel data has been added to the Aruba Health App. Show pre-approved test page upon arrival at the airport and hotel
            (together with valid identification).
          </p>
          <p>
            You can always retrieve your travel data by clicking on your user card, then the "Travel info" button and then the corresponding flight.
          </p>
        </div>
        <div class="col-lg-6">
          <div class="">
            <img class="screenshot" :src="require('@/assets/images/instruction-screenshots/qr-code-travel-data.png')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from '@/components/main-menu.vue';
export default {
  components: {
    MainMenu,
  },
};
</script>

<style lang="scss" >
@import '@/assets/styles/_variables.scss';
.instructions {
  h3 {
    color: $primary;
  }
  .p-text-large {
    font-size: 20px;
  }
  .screenshot {
    max-width: 100%;
    margin: 20px 20px;
    box-shadow: 10px 5px 30px rgba(1, 1, 1, 0.05);

    //float: right;
  }
}
</style>